export { Col, Row } from '@landlord-tech/ui-kit-opp';
export type { ColProps, ColSize, RowProps } from '@landlord-tech/ui-kit-opp';
